"use client";

import { IconSortByMobile } from "@repo/assets/images";
import { useFilterOptions } from "@repo/lib/hooks/catalog";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useState } from "react";
const FilterDefault = ({
  options,
  type
}) => {
  const optionsToShow = 7;
  const t = useTranslations("Common");
  const {
    selectedValues,
    handleCheckboxChange
  } = useFilterOptions();
  const [showMore, setShowMore] = useState(false);
  const visibleOptions = showMore ? options : options.slice(0, optionsToShow);
  const noOfOptionsHidden = options?.length - optionsToShow;
  // Safeguard below to ensure that selectedValues[type] is always defined
  const checkedValues = selectedValues[type] || [];
  return <div data-sentry-component="FilterDefault" data-sentry-source-file="FilterDefault.jsx">
      <ul>
        {visibleOptions?.map(item => <li key={item?.value} className="group mb-4 text-center last:mb-0">
            <label htmlFor={`${item?.value}`} className="flex w-full items-center">
              <input type="checkbox" id={item.value} value={item.value} className="accent-toolbar-filter-active text-toolbar-filter-checkboxTick me-2 size-[14px]" onChange={event => handleCheckboxChange(event, type)} checked={checkedValues?.includes(item.value)} />
              <span className="text-toolbar-filter-text cursor-pointer text-sm">
                {item?.name}
              </span>
              {item.count && <span className="text-toolbar-filter-text ps-[3px] text-sm">{`(${item.count})`}</span>}
            </label>
          </li>)}
      </ul>
      {options?.length > optionsToShow && <button className="text-toolbar-filter-active mx-0 mt-4 flex w-auto flex-row items-center justify-center gap-2 p-0 text-center align-middle text-base font-semibold leading-6 tracking-normal focus-visible:outline-none" onClick={() => setShowMore(!showMore)}>
          <span className="w-full text-center">
            {showMore ? t("See_Less") : `${t("See_More")} (${noOfOptionsHidden})`}
          </span>

          <IconSortByMobile className={cx("text-toolbar-filter-active m-auto size-7 transform justify-self-center px-1 pb-0 pt-3 align-middle transition-transform duration-300", {
        "mt-1 rotate-180 pb-0 pl-2": !showMore
      })} />
        </button>}
    </div>;
};
export default FilterDefault;